angular.module('unergie.main')
.controller('b2gBankDetailsCtrl', ($scope, $state, $filter, DataAccess, AlertManager, ApiUser, OrganizationService, CommonRegex,
    DownloadService, TableGeneratorService, FileUploader, ErrorCatcher) => {
    $scope.ibans = {
        refreshing: false,
        show: {},
        columns: {
            'id': { label: 'Id technique', mode: 'hidden', mandatory: true },
            'siret': { label: 'SIRET', mode: 'search_wildcard' },
            'siret.legal_name': { label: 'Raison sociale', mode: 'search_wildcard' },
            'status': { label: 'Statut', mode: 'search_wildcard' },
            'id_agreement': { label: 'Marché', mode: 'search_wildcard' },
            'payment_modes': { label: 'Modes de paiement', mode: 'search_wildcard' },
            'iban': { label: 'IBAN', mode: 'search_wildcard' },
            'bic': { label: 'BIC', mode: 'search_wildcard' },
            'creation_ts': { label: 'Date', mode: 'search_date' },
            'modificator': { label: 'Dernière modification', mode: 'search_wildcard' },
            'attachment': { label: 'Fichier', mode: 'hidden' },
            'signature_date': { label: 'Date signature', mode: 'search_date' },
        },
    }

    $scope.historyColumns = {
        id: { label: 'ID', mode: 'hidden' },
        status: { label: 'Statut', mode: 'search_wildcard' },
        iban: { label: 'IBAN', mode: 'search_wildcard' },
        bic: { label: 'BIC', mode: 'search_wildcard' },
        modification_ts: { label: 'Date', mode: 'search_date' },
        modificator: { label: 'Dernière modification', mode: 'search_wildcard' },
        attachment: { label: 'Fichier', mode: 'hidden' },
        signature_date: { label: 'Date signature', mode: 'search_date' },
    }

    $scope.refresh = () => TableGeneratorService.getTable($scope.ibans, 'vw-category-iban')

    const doneFetchingHistory = (i) => (data) => {
        i.history.fetched = true
        data.shift()
    }

    $scope.deleteFields = {
        warning: {
            type: 'label',
            label: `<span class="red"><span class="fa fa-warning"></span> Attention : vous êtes sur le point de supprimer la ligne de la base de données de manière irreversible.<br>` +
                `(si la pièce jointe associée n'est utilisée par aucune autre ligne de la base, elle sera également supprimée)</span>`,
        },
    }

    $scope.rejectTemplate = {
        email: true,
    }

    $scope.rejectFields = {
        email: {
            label: `avec envoi de mail au contact de facturation`,
            type: 'checkbox',
        },
    }

    const acceptTemplateTemplate = {
        email: true,
        signature_date: null,
    }

    $scope.acceptTemplate = {
        email: true,
        signature_date: null,
    }

    $scope.resetAcceptTemplate = () => {
        $scope.acceptTemplate = _.clone(acceptTemplateTemplate)
    }

    $scope.acceptFieldsNoMandate = {
        email: {
            label: `avec envoi de mail au contact de facturation`,
            type: 'checkbox',
        },
    }

    $scope.acceptFieldsMandate = {
        email: {
            label: `avec envoi de mail au contact de facturation`,
            type: 'checkbox',
        },
        signature_date: {
            label: `Date de signature du mandat`,
            type: 'date',
            required: true,
        },
    }

    $scope.processing = (iban) => {
        return iban.rejecting || iban.accepting || iban.deleting
    }

    $scope.refreshIbanHistory = function (i) {
        i.history = {
            columns: _.clone($scope.historyColumns),
            preventAddressBar: true,
        }
        return TableGeneratorService.getTable(i.history, 'category-iban-history', null, doneFetchingHistory(i), {
            search: { siret: i.siret, id_agreement: i.id_agreement },
            orderBy: '-modification_ts',
        })
    }


    $scope.fetchUnmaskedIban = (i, e) => {
        e.preventDefault()
        e.stopPropagation()
        if (i.fetchingUnmaskedIban) {
            return
        }
        i.fetchingUnmaskedIban = true
        return DataAccess.showCategoryIban({ id: i.id }).$promise.then((result) => {
            i.unmaskedIban = result.iban
        })
        .catch(ErrorCatcher)
        .finally(() => {
            i.fetchingUnmaskedIban = false
        })
    }

    $scope.fetchUnmaskedIbanHisto = (h, e) => {
        e.preventDefault()
        e.stopPropagation()
        if (h.fetchingUnmaskedIban) {
            return
        }
        h.fetchingUnmaskedIban = true
        return DataAccess.showCategoryHistoIban({ id: h.id }).$promise.then((result) => {
            h.unmaskedIban = result.iban
        })
        .catch(ErrorCatcher)
        .finally(() => {
            h.fetchingUnmaskedIban = false
        })
    }

    const changeSiretIbanStatus = (i, status) => {
        if (i.accepting || i.rejecting) {
            return
        }
        i[status === 'REJECTED' ? 'rejecting' : 'accepting'] = true
        const payload = _.assign({ status }, status === 'REJECTED' ? $scope.rejectTemplate : $scope.acceptTemplate)
        return DataAccess.changeSiretIbanStatus({ id: i.id }, payload).$promise.then((result) => {
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            i[status === 'REJECTED' ? 'rejecting' : 'accepting'] = false
        })
    }

    $scope.reject = (i) => changeSiretIbanStatus(i, 'REJECTED')
    $scope.accept = (i) => changeSiretIbanStatus(i, 'VALIDATED')

    $scope.maskIban = (i, e) => {
        e.preventDefault()
        e.stopPropagation()
        i.unmaskedIban = null
    }

    $scope.toggleExpand = (i) => {
        if (i) {
            i.expanded = !i.expanded
        }
        if (!i.history) {
            $scope.refreshIbanHistory(i)
        }
    }

    $scope.createIbanFields = {
        organization: {
            label: 'Organisation',
            type: 'typeahead',
            required: true,
            enum: [],
            limitTo: 20,
            onSelect: (organization) => {
                $scope.createIbanPayload.id_agreement = null
                if (organization) {
                    return DataAccess.getAgreementsForOrg({ organization }).$promise
                    .then((agreements) => {
                        $scope.createIbanFields.id_agreement.enum = _.map(_.filter(agreements, { type: 'ELEC' }), (a) => ({ label: a.id, value: a.id }))
                        if ($scope.createIbanFields.id_agreement.enum.length === 1) {
                            $scope.createIbanPayload.id_agreement = $scope.createIbanFields.id_agreement.enum[0].value
                        }
                    })
                }
            },
        },
        id_agreement: {
            label: 'Marché',
            type: 'select',
            required: true,
            enum: [],
            limitTo: 20,
        },
        siret: {
            label: 'Siret',
            type: 'text',
            required: true,
            pattern: /\d{14}/,
        },
        iban: {
            label: 'IBAN',
            type: 'iban',
            required: true,
        },
        bic: {
            label: 'BIC',
            type: 'text',
            required: true,
            pattern: CommonRegex.bic,
        },
        attachment: {
            label: 'Fichier',
            type: 'file',
            fileNumber: 1,
            required: true,
        },
    }

    OrganizationService.getOrgz().then((data) => {
        $scope.createIbanFields.organization.enum = _.map(_.filter(data, (d) => ['B2B', 'B2G'].includes(d.type)), (d) => ({ label: d.id, value: d.id }))
    })

    $scope.updateIbanFields = {
        iban: {
            label: 'IBAN',
            type: 'iban',
            required: true,
        },
        bic: {
            label: 'BIC',
            type: 'text',
            required: true,
            pattern: CommonRegex.bic,
        },
        attachment: {
            label: 'Fichier (ou utiliser existant)',
            type: 'file',
            fileNumber: 1,
        },
    }

    $scope.createIbanPayload = {
        attachment: new FileUploader({
            alias: 'file',
            formData: [],
            autoUpload: false,
            removeAfterUpload: true,
            method: 'POST',
            onSuccessItem(item, response, status, headers) {
                AlertManager.success(`Iban ajouté`)
                $scope.creatingIban = false
                $scope.refresh()
            },
            onErrorItem(item, response, status, headers) {
                $scope.creatingIban = false
                return ErrorCatcher(response)
            },
            onBeforeUploadItem(item) {
                $scope.creatingIban = true
                item.url = `/api-user/siret/${$scope.createIbanPayload.siret}/iban`
                item.formData.push(_.omit($scope.createIbanPayload, ['attachment']))
            },
        }),
    }

    $scope.createIban = function () {
        return $scope.createIbanPayload.attachment.uploadAll()
    }

    $scope.prepareUpdateIbanPayload = function (i) {
        $scope.updateIbanPayload = {
            siret: i.siret,
            id_agreement: i.id_agreement,
            attachment: new FileUploader({
                alias: 'file',
                formData: [],
                autoUpload: false,
                removeAfterUpload: true,
                method: 'POST',
                onSuccessItem(item, response, status, headers) {
                    AlertManager.success(`Iban modifié`)
                    $scope.refresh()
                },
                onErrorItem(item, response, status, headers) {
                    return ErrorCatcher(response)
                },
                onBeforeUploadItem(item) {
                    item.url = `/api-user/siret/${i.siret}/iban`
                    item.formData.push(_.omit($scope.updateIbanPayload, ['attachment']))
                },
            }),
        }
    }

    $scope.updateIban = function () {
        if ($scope.updateIbanPayload.attachment.queue.length) {
            return $scope.updateIbanPayload.attachment.uploadAll()
        }
        return ApiUser.createSiretIban({ siret: $scope.updateIbanPayload.siret }, _.pick($scope.updateIbanPayload, ['iban', 'bic', 'id_agreement'])).$promise.then((result) => {
            AlertManager.success(`Iban modifié`)
            $scope.refresh()
        })
        .catch(ErrorCatcher)
    }

    $scope.delete = (iban) => {
        iban.deleting = true
        return ApiUser.deleteCategoryIban({ id: iban.id }).$promise.then((result) => {
            AlertManager.success(`Révision supprimée`)
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            iban.deleting = false
        })
    }

    $scope.download = (file, e) => {
        e.preventDefault()
        e.stopPropagation()
        DownloadService.downloadFile(`/api-admin/s3-download?file=${file}`)
    }

    const activate = () => {
        $scope.refresh()
    }

    activate()
})
